// extracted by mini-css-extract-plugin
export default {"AboutArea":"AboutArea_AboutArea__Rx7Mj","AboutImage":"AboutArea_AboutImage__wNksv","AboutTexts":"AboutArea_AboutTexts__3Q2b1"};